import {
    MDBAlert, MDBBtn,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React from 'react';
import ForgotUserId from './ForgotUserId';
const ForgotUserIdModal = ({ isForgotUserId,setIsForgotUserId, isForgotPassword,setIsForgotPassword,setCountDown,setAlertMessage,alertMessage, setShowAlert,showAlert,countDown}) => {

   
        return (
     
        
        <MDBModal staticBackdrop={true} closeOnEsc={false}
            animationDirection='right'
            open={isForgotPassword || isForgotUserId}
            centered={true}
            onClose={()=>{setIsForgotPassword(false);setIsForgotUserId(false)}}>
            
            <MDBModalDialog  >
            <MDBAlert open={showAlert}
                    color='warning'
                    autohide={true}
                    delay={10000}
                    onClose={() => setShowAlert(false)}
                >
                   <MDBIcon fas icon={alertMessage?.toLowerCase().includes('error') ? 'times-circle' : 'check-circle'} className='me-3' />
<span className='text-primary' dangerouslySetInnerHTML={{ __html: alertMessage }} />     <MDBBtn className="btn-close ms-2" color='success' onClick={()=> setShowAlert(false)}></MDBBtn>

                </MDBAlert>
            <MDBModalContent >
                <MDBModalBody >
                <ForgotUserId
                    isForgotPassword = {isForgotPassword}
                    setIsForgotPassword={setIsForgotPassword}
                    isForgotUserId = {isForgotUserId}
                    setIsForgotUserId={setIsForgotUserId}
                    setShowAlert={setShowAlert}
                    setAlertMessage = {setAlertMessage}
                    setCountDown = {setCountDown}
                    countDown = {countDown}
                  />
                </MDBModalBody>

          
                </MDBModalContent>
                
            </MDBModalDialog>
        </MDBModal>
  
    )
};
ForgotUserIdModal.propTypes = {
    isForgotPassword: PropTypes.bool,
    setIsForgotPassword:PropTypes.func,
    isForgotUserId: PropTypes.bool,
    setIsForgotUserId: PropTypes.func,
    setCountDown: PropTypes.func,
    setAlertMessage: PropTypes.func,
    setShowAlert: PropTypes.func,
    alertMessage:PropTypes.string,
    showAlert: PropTypes.bool,
    countDown: PropTypes.number,

}
export default ForgotUserIdModal;
